export enum FilterOptionsEnum {
  All = 'All',
  None = 'None',
}
